import type { FunctionMeta } from '../function.model';

/**
 * Quadratic function in vertex form: f(x) = a(x - h)² + k
 *
 * - a: vertical stretch/compression and reflection
 * - h: horizontal shift (vertex x-coordinate)
 * - k: vertical shift (vertex y-coordinate)
 */
export interface QuadraticVertexParams {
  a: number;
  h: number;
  k: number;
}

export const QUADRATIC_VERTEX_META: FunctionMeta<QuadraticVertexParams> = {
  availableFeatures: [
    'handle',
    'roots',
    'extrema',
    'tangent',
    'secant',
    'derivative',
    'axisOfSymmetry',
    'intersection',
    'yIntercept',
    'trajectory',
    'monotonicity',
    'functionArea',
    'intersectionArea',
    'domain',
    'range',
  ],
  handleConfigs: {
    translate: { xParam: 'h', yParam: 'k' },
    'translate-x': { xParam: 'h', yParam: 'k' },
    'translate-y': { xParam: 'h', yParam: 'k' },
  },
  defaultParams: {
    a: 1,
    h: 0,
    k: 0,
  },
  defaultRanges: {
    a: [-5, 5],
    h: [-10, 10],
    k: [-10, 10],
  },
};
